import { useQuery } from 'react-query';
import { CCTemplateVersions, changeControlApi } from '../api/changeControl';

export const useCCTemplateVersions = (
  companyId: number,
  templateMatrixId: string | undefined,
): {
  ccTemplateVersions: CCTemplateVersions | undefined;
  isLoading: boolean;
} => {
  const { data: ccTemplateVersions, isLoading } = useQuery<CCTemplateVersions>({
    queryKey: ['ccTemplateVersions', templateMatrixId],
    queryFn: () =>
      changeControlApi.fetchChangeControlTemplateVersions(
        companyId,
        templateMatrixId as string,
      ),
    enabled: !!templateMatrixId,
    refetchOnWindowFocus: false,
  });

  return { ccTemplateVersions, isLoading };
};
